import * as Styled from './app-layout.style';

export const AppLayout = Styled.Container;
